module.exports = "/_next/static/images/firefox-6057403b67839d548d3e014c72db0737.svg";